import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-onboarding-header',
  templateUrl: './onboarding-header.component.html',
  styleUrls: ['./onboarding-header.component.scss'],
  host: { class: 'onboarding-banner__header' }
})
export class OnboardingHeaderComponent {

  @Input() title: string = '';
  @Input() subtitle: string = '';

}
